/**
 * NOTE: echart 文档：https://echarts.apache.org/zh/option.html#title
 * NOTE: echarts-for-react 文档： https://github.com/hustcc/echarts-for-react
 */
import ReactEChartsCore from 'echarts-for-react/lib/core'
/** NOTE: 以下是按需引入的 */
import { EChartsReactProps } from 'echarts-for-react/lib/types'
import * as echarts from 'echarts/core'
import {
  LineChart,
  BarChart,
  // PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  // GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from 'echarts/charts'
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  MarkLineComponent,
  // MarkAreaComponent,
  LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components'
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers'

echarts.use([
  /** 渲染的 component */
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  /** 使用到的 chart 组件 */
  LineChart,
  MarkLineComponent,
  // MarkAreaComponent,
  BarChart,
  CanvasRenderer,
])

function ReactChart(props: EChartsReactProps) {
  return <ReactEChartsCore {...props} echarts={echarts} />
}

export default ReactChart
